import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();
  return (
    <>
      <section className="hero-billboard relative w-full h-[60vh] min-h-[460px] md:h-[82vh] md:min-h-[640px] overflow-hidden">
        <img
          src="/images/generated/facility-odaiba-img.jpg"
          alt={t('aboutAcademy.hero.imgAlt')}
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 hero-overlay"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="relative w-full px-8">
            <div className="max-w-[800px] mx-auto text-center">
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-50 tracking-[0.08em] mb-4">
                {t('aboutAcademy.hero.title')}
              </h1>
              {String(t('aboutAcademy.hero.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] md:text-[17px] tracking-[0.12em] mb-6">{__s}</p>))}
              {String(t('aboutAcademy.hero.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-200/80 tracking-[0.05em] leading-relaxed max-w-[640px] mx-auto">{__s}</p>))}
            </div>
          </div>
        </div>
      </section>

      <nav aria-label="パンくずリスト" className="bg-background-50 border-b border-background-200">
        <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 py-3 flex items-center gap-2 text-[13px] text-foreground-500">
          <Link to="/" className="hover:text-accent-600 transition-colors">
            {t('aboutAcademy.hero.homeLink')}
          </Link>
          <i className="ri-arrow-right-s-line text-foreground-400 text-[12px]"></i>
          <span className="text-foreground-700">{t('aboutAcademy.hero.currentPage')}</span>
        </div>
      </nav>
    </>
  );
}
